import { Centered, EllipsedText } from '@gorila-shared-ui/components';
import { ListItem, ListItemLabel } from 'baseui/list';
import { Spinner } from 'baseui/spinner';
import { CSSProperties, memo } from 'react';
import { ListChildComponentProps } from 'react-window';
import { ASSET_TYPE } from '../../../constants/asset';
import { useStyles } from '../../../hooks/useStyles';
import { Asset, AssetMinimal } from '../../../types/asset';
import { getAssetTitle } from '../../../utils/assets';

function SearchAssetItem({
  data,
  index,
  style,
}: Readonly<
  ListChildComponentProps<{
    assets: Array<AssetMinimal | Asset>;
    onClick: (asset: Asset | AssetMinimal) => void;
  }>
>) {
  const asset = data.assets[index];
  const { theme } = useStyles();

  if (!asset) {
    return (
      <span style={style as CSSProperties}>
        <Centered>
          <Spinner $size={theme.sizing.scale900} />
        </Centered>
      </span>
    );
  }

  const assetTitle = getAssetTitle(asset, true, true, '');
  const name = asset?.label;
  const title = (() => {
    if (name && assetTitle) {
      return `${name} (${assetTitle})`;
    }
    if (!name && assetTitle) {
      return assetTitle;
    }
    return name ?? '';
  })();

  return (
    <span style={style as CSSProperties}>
      <ListItem
        onClick={() => {
          data.onClick(asset);
        }}
        overrides={{
          Root: {
            style: {
              transition: '0.3s background',
              ':hover': {
                background: theme.colors.buttonTertiaryHover,
              },
            },
          },
        }}
      >
        <ListItemLabel description={ASSET_TYPE[asset.assetType] || '-'}>
          <EllipsedText inline>{title}</EllipsedText>
        </ListItemLabel>
      </ListItem>
    </span>
  );
}

export default memo(SearchAssetItem);
